import React from 'react';
import { useIntl } from 'react-intl';

import FilterChip from '~/components/Shared/Filters/FilterChip/FilterChip';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { SearchFilter } from '~/types/DashboardV2';

import { getWorkflowsFilterRendererAndSerializer } from './AsyncWorkflowsOptions';

export type Props = {
  onChange: (value: {
    contract_types?: string[];
    workflow_ids?: string[];
  }) => void;
  value?: {
    contract_types?: string[];
    workflow_ids?: string[];
  };
};

export const ScopeSelect = ({ value, onChange }: Props) => {
  const intl = useIntl();
  const { render: workflowsRenderer, serialize: workflowsSerializer } =
    getWorkflowsFilterRendererAndSerializer();

  const WorkflowSearchFilter: SearchFilter = {
    id: 'workflow',
    label: 'Workflow',
    type: 'enum_set' as const,
    operators: [
      {
        id: 'contains_any',
        label: intl.formatMessage({
          id: 'ScopeSelect.containsAnyOperatorLabel',
          defaultMessage: 'contains any of',
          description:
            'Label for the contains any operator in workflow scope filter',
        }),
        cardinality: Number.POSITIVE_INFINITY,
      },
    ],
    section: '',
    is_chartable: true,
    is_requestable_column: false,
    settings: {
      maxWidth: 300,
      options: [],
      __testEnableSelectAll: () => false,
    },
    render: workflowsRenderer,
    serialize: workflowsSerializer,
  };

  return (
    <Layout align="center" spacing={2}>
      <FilterChip
        disableRemove={false}
        searchFilter={WorkflowSearchFilter}
        disableEdit={value?.contract_types && value.contract_types.length > 0}
        filter={{
          id: 'some_uuid_2',
          fieldId: 'workflow',
          operatorId: value?.workflow_ids?.length ? 'contains_any' : null,
          values: value?.workflow_ids ?? [],
        }}
        onChange={(filter) => {
          onChange({
            ...value,
            workflow_ids: filter.values as string[],
          });
        }}
      />
    </Layout>
  );
};
